<!--Vista que muestra la lista de asistentes de un evento en específico
    A esta vista solo pueden acceder los usuarios de tipo ORGANIZADOR y se puede llegar a ella
    dando click en "Ver asistentes" o dando click en el número de asistentes en la tabla de
    eventos que sale en el dashboard.
-->
<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="10" md="8" xl="6" class="elevation-1 mb-5 primary white--text text-center">
            <h1 class="display-2">{{ event.name }}</h1>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" md="11" class="elevation-2 pa-5">
            <v-row justify="space-around">
              <v-col cols="12" md="7" class="text-center text-md-left pb-0">
                <span class="headline font-weight-bold mr-5">Asistentes</span>
                <v-btn color="accent" class="black--text font-weight-bold ma-1" @click="downloadCsv(event.assistants, event.name)">
                  Reporte<v-icon right>mdi-download</v-icon>
                </v-btn>
                <v-tooltip v-if="event.id == '601c44ead689f90008e03fe8'" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="#a41414" class="black--text font-weight-bold ma-1" @click="downloadEstafetaCsv(event.assistants, event.name)" v-bind="attrs" v-on="on">
                      <span class="white--text">
                        Estafeta<v-icon right>mdi-download</v-icon>
                      </span>
                    </v-btn>
                  </template>
                  <span>Da click para descargar un reporte con un formato similar al de estafeta</span>
                </v-tooltip>
                <v-tooltip v-if="event.id == '60b0004924a1bf0007903519'" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="#a41414" class="black--text font-weight-bold ma-1" @click="downloadEstafetaCsvTheGroomWeek(event.assistants, event.name)" v-bind="attrs" v-on="on">
                      <span class="white--text">
                        Estafeta<v-icon right>mdi-download</v-icon>
                      </span>
                    </v-btn>
                  </template>
                  <span>Da click para descargar un reporte con un formato similar al de estafeta</span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="5" class="pt-0">
                <v-row>
                  <v-col :cols="(items.length >=400 || advancedSearch.verify === true)?'10':'12'">
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                      class="mr-0 mr-md-5 pt-0"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" v-if="items.length >=400 || advancedSearch.verify === true">
                    <v-dialog v-model="advancedSearch.dialog" max-width="600px" transition="dialog-top-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="accent" class="white--text font-weight-bold" v-on="on" v-bind="attrs">
                        <v-icon>fas fa-search</v-icon>
                      </v-btn>
                      <small>Búsqueda avanzada</small>
                    </template>
                      <v-card v-if="advancedSearch.dialog">
                        <v-form ref="form" v-model="valid" lazy-validation>
                        <v-divider class="pt-3"></v-divider>
                        <v-row class="ma-0">
                          <v-col cols="12" class="px-5">
                            <span>Eija un filtro</span>
                            <v-select :items="advancedSearch.filters" v-model="advancedSearch.filter" required prepend-icon="fas fa-filter"></v-select>
                          </v-col>
                          <v-col v-if="advancedSearch.filter != 'updatedAt'" cols="12" class="px-5 d-flex">
                            <v-text-field
                              v-model="advancedSearch.search"
                              label="Buscar"
                              :rules="required"
                              prepend-icon="fas fa-search"
                            ></v-text-field>
                          </v-col>
                          <v-col
                          v-if="advancedSearch.filter == 'updatedAt'"
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-menu
                              ref="menu"
                              v-model="advancedSearch.menu"
                              :close-on-content-click="false"
                              :return-value.sync="advancedSearch.date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="advancedSearch.date"
                                  label="Elija la fecha"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="advancedSearch.date"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="advancedSearch.menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu.save(advancedSearch.date)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-card-actions class="px-7 pb-4">
                          <v-row justify="space-between">
                            <v-btn color="red darken-3" @click="closeAdvancedSearch()" dark>Cancelar</v-btn>
                            <v-btn color="accent" :disabled="!valid || (advancedSearch.filter != 'updatedAt' && advancedSearch.search == '')" :loading="advancedSearch.load" @click="advancedSearchFunction( advancedSearch)">Buscar</v-btn>
                          </v-row>
                        </v-card-actions>
                        </v-form>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :loading="loading"
              loading-text="Cargando datos..."
              no-data-text="No hay datos disponibles."
              no-results-text="No hay datos disponibles."
              :header-props="{
                sortByText:'Ordenar por'
              }"
              :footer-props="{
                itemsPerPageText: 'Filas por página',
                itemsPerPageAllText:'Todas',
              }"
            >
              <template v-slot:body="{items}">
                <tbody>          
                  <tr
                    v-for="(item, index) in items"
                    :key="index"
                    class="text-center"
                    :class="[(item.checkedIn===true)?'attended-color':'', ($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-table-row':'' ]"
                  >
                    <td class="px-1" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[0].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.name}}</div>
                    </td>
                    <td class="px-1" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[1].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.lastName}}</div>
                    </td>
                    <td class="px-1" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[2].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{item.companyName}}</div>
                    </td>
                    <td class="px-1" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[3].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.email}}</div>
                    </td>
                    <td class="px-1" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[4].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.productName }}</div>
                    </td>
                    <td class="px-1" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[5].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.date }}</div>
                    </td>
                    <td class="px-1" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[6].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >{{ item.hour }}</div>
                    </td>
                    <td class="px-1" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[7].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >
                      <v-switch v-model="item.checkedIn" color="success" @change="checkIn(item)" class="justify-center"></v-switch>
                      </div>
                    </td>
                    <td class="px-1" :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row':''">
                      <div
                        class="font-weight-bold mr-2 v-data-table__mobile-row__header d-flex d-sm-none"
                      >{{headers[8].text}}</div>
                      <div
                        :class="($vuetify.breakpoint.xsOnly)?'v-data-table__mobile-row__cell':''"
                      >
                        <v-chip
                          class="pointer ma-1"
                          color="accent"
                          dark
                          @click.native.stop="selectAttendeeTicket(item)"
                        >Enviar boleto</v-chip>
                        <v-chip
                          class="pointer ma-1"
                          color="primary"
                          dark
                          @click.native.stop="editAttendee(item)"
                        >Editar</v-chip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
            <v-col cols="12" v-if="advancedSearch.verify === true" class="text-center">
              <span class="text-center pointer" @click="pageNumber = 1, formatData()"> Restablecer todos los datos</span>
              <v-tooltip top max-width="350px">
                <template v-slot:activator="{ on }">
                  <v-icon color="primary" dark v-on="on"
                    >mdi-help-circle</v-icon
                  >
                </template>
                <span>Da click para restablecer los filtros de búsqueda avanzada.</span>
              </v-tooltip>
            </v-col>
            <v-row v-if="eventAttendees.orders.length >=400" justify="end" class="mt-5">
              <v-btn class="primary" @click="fetchMoreAttendees()" :loading="loadingMoreAttendees" :disabled="disabledAttendeesButton || advancedSearch.verify == true">
                Cargar más asistentes ...
              </v-btn>
            </v-row>
            <v-dialog v-model="sendTicketDialog" max-width="600px">
              <v-card v-if="sendTicketDialog">
                <v-row justify="space-between" class="mx-0 px-0">
                  <v-col cols="10" class="pb-0 ma-0">
                    <p class="title font-weight-bold text-left pl-2 ma-0"> {{($vuetify.breakpoint.xsOnly)?'Envío de Acceso':'Envío manual de Acceso / Boleto'}}</p>
                  </v-col>
                  <v-col cols="2" class="pb-0 px-0 ma-0">
                    <i class="fas fa-ticket-alt fa-2x amber--text"></i>
                  </v-col>
                </v-row>
                <v-divider class="pt-3"></v-divider>
                <v-row class="ma-0">
                  <v-col cols="12" class="px-5">
                    <p><strong>Nombre:</strong> {{sendTicketItem.name}}</p>
                    <p><strong>Apellidos:</strong> {{sendTicketItem.lastName}}</p>
                    <p><strong>Boleto:</strong> {{sendTicketItem.productName}}</p>
                    <p><strong>Fecha de compra:</strong> {{sendTicketItem.date}}</p>
                    <p><strong>Comprador:</strong> {{sendTicketItem.buyer}}</p>
                  </v-col>
                  <v-col cols="12" class="px-5 d-flex">
                    <v-text-field
                      v-model="sendTicketItem.email"
                      :rules="emailRules"
                      label="E-mail que recibirá el boleto / acceso"
                      required
                      prepend-icon="fas fa-envelope"
                    ></v-text-field>
                    <v-tooltip top max-width="350px">
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                      </template>
                      <span>En algunas ocasiones por la configuración de seguridad del asistente, los correos entran a la carpeta de SPAM. No te preocupes, aquí puedes enviar de nuevo cualquier boleto / acceso.</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions class="px-7 pb-4">
                  <v-row justify="space-between">
                    <v-btn color="red darken-3" @click="closeSendTicket()" dark>Cancelar</v-btn>
                    <v-btn color="accent" @click="sendTicket( sendTicketItem)">Enviar</v-btn>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="modifyDialog" max-width="900px">
              <v-card v-if="modifyDialog">
                <v-card-title>
                  <span class="headline">Editar información del asistente</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.name"
                            :rules="nameRules"
                            label="Nombre(s)"
                            required
                            prepend-icon="fas fa-user"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.lastName"
                            :rules="lastNameRules"
                            label="Apellidos"
                            required
                            prepend-icon="fas fa-user"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.companyName"
                            :rules="companyRules"
                            label="Compañía"
                            required
                            prepend-icon="fas fa-industry"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.email"
                            :rules="emailRules"
                            label="E-mail"
                            required
                            prepend-icon="fas fa-envelope"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="editedItem.extraFields.accessType != 'ON_SITE' && event.attendeeWithPassword && event.attendeeWithPassword != 'DISABLED'" cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.passwordAccess"
                            label="Contraseña"
                            prepend-icon="fas fa-key"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.tel"
                            :rules="phoneRules"
                            label="Teléfono"
                            required
                            prepend-icon="fas fa-phone"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions class="px-7 pb-4">
                  <v-row justify="space-between">
                    <v-btn color="red darken-3" @click="close()" dark>Cancelar</v-btn>
                    <v-btn color="accent" :disabled="!valid" :loading="load" @click="updateAttendeeFunction(editedItem)">Guardar</v-btn>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { validations } from "@/helpers/validations.js";
import { mapMutations, mapState, mapActions } from "vuex";
import exportFromJSON from "export-from-json";
export default {
  data() {
    return {
      search: "",
      loading: true,
      sendTicketDialog: false,
      modifyDialog: false,
      load:false,
      items: [],
      headers: [
        { align: "center", text: "Nombre", value: "name" },
        { align: "center", text: "Apellidos", value: "lastName" },
        { align: "center", text: "Empresa", value: "companyName" },
        { align: "center", text: "Email", value: "email" },
        { align: "center", text: "Boleto", value: "productName" },
        { align: "center", text: "Fecha", value: "date" },
        { align: "center", text: "Hora", width: "90px", value: "hour"},
        { align: "center", text: "Checked In", value: "checkedIn" },
        { align: "center", text: "Acciones", value: "sendTicket" },
      ],
      valid:true,
      advancedSearch: {
        menu:false,
        date: new Date().toISOString().substr(0, 10),
        load:false,
        verify: false,
        search:"",
        dialog:false,
        filter:'name',
        filters: [
          { text: "Nombre", value: "name" },
          { text: "Apellidos", value: "lastName" },
          { text: "Email", value: "email" },
          { text: "Fecha", value: "updatedAt" },
        ],
      },
      checkInData: {},
      ticketData: {},
      updateData:{},
      patronSpace: / /g,
      sendTicketItem: {
        orderId: "",
        attendeeId: "",
        name: "",
        lastName: "",
        companyName: "",
        email: "",
        productName: "",
        date: "",
        buyer: ""
      },
      defaultItem: {
        orderId: "",
        attendeeId: "",
        name: "",
        lastName: "",
        companyName: "",
        email: "",
        tel: "",
        productName: "",
        date: "",
        buyer: "",
      },
      editedItem: {},
      required: validations.requiredValidation(),
      emailRules: validations.emailValidation(),
      nameRules: validations.nameValidation(),
      lastNameRules: validations.surnamesValidation(),
      phoneRules: validations.phoneValidation(),
      companyRules: validations.nameValidation({
        required: false,
        minLength: 2,
        name: "nombre de la empresa"
      }),
      event: {
        id: "",
        name: "Cargando nombre de evento ..."
      },
      disabledAttendeesButton: false,
      loadingMoreAttendees: false,
      pageNumber: 1,
      allQtyOrdersOld: 0,
      allQtyOrdersNew: 0,
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("event", ["eventAttendees"])
  },
  methods: {
    ...mapMutations("notifications", ["show"]),
    ...mapMutations("event", ["clearEventAttendeesInformation"]),
    ...mapActions("order", ["checkInManual", "sendTicketManual","updateAttendee"]),
    ...mapActions("event", ["fetchUserEvents", "fetchEventsAttendeeApi","searchAttendee"]),
    /**
     * Función para descargar el reporte de los asistentes.
     * @param { String } eventName Nombre del evento.
     */
    async downloadCsv(assistants, eventName) {
      let data = await this.getAssistants();
      const fileName = `Asistentes ${eventName}`;
      const exportType = "csv";
      // Ordenar por apellido de manera ascendente.
      data.sort(function(a, b) {
        if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
          return 1;
        }
        if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      exportFromJSON({ data, fileName, exportType });
    },
    /**
     * Dar formato a lista de asistentes para poder acomodarlos en el archivo .CSV
     * */
    getAssistants() {
      let items = [];
      this.event.assistants.forEach(async assistant => {
        //assistant.extraFields.orderId = assistant.orderId;
        assistant.extraFields.lastName = assistant.extraFields.lastName.trim();
        assistant.extraFields.email = assistant.extraFields.email.trim();
        assistant.extraFields.companyName = assistant.extraFields.companyName != ""?assistant.extraFields.companyName:"N/D"
        assistant.extraFields.tel = assistant.extraFields.tel != ""?assistant.extraFields.tel:"N/D"
        assistant.extraFields.checkedIn = assistant.checkedIn;
        assistant.extraFields.checkedIn = assistant.extraFields.checkedIn ? 'Si': 'No';
        assistant.extraFields.date = assistant.date;
        assistant.extraFields.hour = assistant.hour;
        //Elimina el campo en el excel de passwordAccess si no lo requiere el evento
        if(this.event.attendeeWithPassword == 'DISABLED' || this.event.attendeeWithPassword == undefined)
        {
          delete assistant.extraFields.passwordAccess;
        }
        //assistant.extraFields.paymentType = assistant.paymentType;
        //assistant.extraFields.billingAddress = assistant.billingAddress;
        //assistant.extraFields.billingEmail = assistant.billingEmail;
        //assistant.extraFields.billingFormaDePago = assistant.billingFormaDePago;
        //assistant.extraFields.billingMetodoDePago = assistant.billingMetodoDePago;
        //assistant.extraFields.billingRazonSocial = assistant.billingRazonSocial;
        //assistant.extraFields.billingRFC = assistant.billingRFC;
        //assistant.extraFields.billingUsoDelCFDI = assistant.billingUsoDelCFDI;
        //assistant.extraFields.billingZipCode = assistant.billingZipCode;

        
        //assistant.extraFields.updatedAt = assistant.updatedAt;
        //assistant.extraFields.orderId = assistant.orderId;
        //Columnas para ver el método de pago y el total de la orden
        //assistant.extraFields.paymentType = assistant.paymentType;
        //assistant.extraFields.total = assistant.total;
        if (this.user.id == '60f739f124a1bf000790b7bc') {
          let itemAux = {...{QRCode:`{"attendeeId":"${assistant.attendeeId}","orderId":"${assistant.orderId}"}`}, ...assistant.extraFields}
          await items.push(itemAux);  
        } else {
          await items.push(assistant.extraFields);
        }
      });
      return items;
    },
    /********************************************INICIO CVDL****************************************/
    /**
     * Función para descargar el reporte de los asistentes con el formato para estafeta.
     * @param { String } eventName Nombre del evento.
     */
    async downloadEstafetaCsv(assistants, eventName) {
      let data = await this.getAssistantsEstafeta();
      const fileName = `Reporte estafeta ${eventName}`;
      const exportType = "csv";
      exportFromJSON({ data, fileName, exportType });
    },
    /**
     * Dar formato a lista de asistentes para poder acomodarlos en el archivo .CSV del reporte para estafeta
     * */
    getAssistantsEstafeta() {
      /*
        Diferentes columnas del reporte de estafeta
          ticketId
          accessType
          ticketName
          ticketPrice
          name
          lastName
          companyName
          Clinica_o_intitucion
          date
          email
          passwordAccess
          Celular
          tel
          Especialidad
          Grado_academico
          Titulo
          backpack
          book
          t_shirt
          size
          zipCode
          country
          state
          city
          suburb
          street
          outsideNumber
          insideNumber
          placeDescription
       */
      let items = [];
      this.event.assistants.forEach(async assistant => {
        let assistantAux = {
          nombreCorto: '',
          categoria: '',
          nombrePersona: '',
          correoElectronicoUno: '',
          correoElectronicoDos: '',
          pais: '',
          razonSocial: '',
          calleUno: '',
          calleDos: '',
          colonia: '',
          CP: '',
          telefonoConLada: '',
          telefonoCelular: '',
          municipio: '',
          estado: '',
          nombreAsistente: '',
          apellidoAsistente: '',
          //companiaAsistente: '',
          clinicaInsitucion: '',
          tipoAccesso: '',
          nombreAcceso: '',
          precioAcceso: '',
          fechaRegistro: '',
          horaRegistro: '',
          emailAsistente: '',
          contrasenaAsistente: '',
          //telefono: '',
          celular: '',
          especialidad: '',
          gradoAcademico: '',
          tituloAcademico: '',
          mochila: '',
          libro: '',
          playera: '',
          tallaPlayera: '',
        };
        console.log(assistant);

        assistantAux.nombreCorto = assistant.attendeeId;
        assistantAux.categoria = 'otros';
        assistantAux.nombrePersona = assistant.name.trim() + ' ' + assistant.lastName.trim();
        assistantAux.correoElectronicoUno = assistant.email;
        assistantAux.correoElectronicoDos = '';
        assistantAux.pais = assistant.extraFields.country;
        assistantAux.razonSocial = assistant.name.trim().split(" ")[0] + " " + assistant.lastName.trim().split(" ")[0];
        //let calleUnoAux = assistant.extraFields.insideNumber && assistant.extraFields.insideNumber!=undefined && assistant.extraFields.insideNumber!=''?(' Num int: ' + assistant.extraFields.insideNumber):'';
        //assistantAux.calleUno = assistant.extraFields.street.trim() + ' ' + assistant.extraFields.outsideNumber + calleUnoAux;
        // Comprobar si es un registro en el cual se tenía la calle y el número separado. Si es así juntar los campos de street, outsideNumber e insideNumber
        if (assistant.extraFields.outsideNumber) {
          let calleUnoAux = assistant.extraFields.insideNumber && assistant.extraFields.insideNumber!=undefined && assistant.extraFields.insideNumber!=''?(' Int: ' + assistant.extraFields.insideNumber):'';
          assistantAux.calleUno = assistant.extraFields.street.trim() + ' ' + assistant.extraFields.outsideNumber + calleUnoAux;
        } else {
          assistantAux.calleUno = assistant.extraFields.street.trim();
        }
        assistantAux.calleDos = assistant.extraFields.placeDescription;
        assistantAux.colonia = assistant.extraFields.suburb;
        assistantAux.CP = assistant.extraFields.zipCode;
        assistantAux.telefonoConLada = assistant.extraFields.Celular;
        assistantAux.telefonoCelular = assistant.extraFields.Celular;
        assistantAux.municipio = assistant.extraFields.city;
        assistantAux.estado = assistant.extraFields.state;
        assistantAux.nombreAsistente = assistant.extraFields.name;
        assistantAux.apellidoAsistente = assistant.extraFields.lastName;
        //assistantAux.companiaAsistente = assistant.extraFields.companyName;
        assistantAux.clinicaInsitucion = assistant.extraFields.Clinica_o_institucion;
        assistantAux.tipoAccesso = assistant.extraFields.accessType;
        assistantAux.nombreAcceso = assistant.extraFields.ticketName;
        assistantAux.precioAcceso = assistant.extraFields.ticketPrice;
        assistantAux.fechaRegistro = assistant.date;
        assistantAux.horaRegistro = assistant.hour;
        assistantAux.emailAsistente = assistant.extraFields.email;
        assistantAux.contrasenaAsistente = assistant.extraFields.passwordAccess;
        //assistantAux.telefono = assistant.extraFields.tel;
        assistantAux.celular = assistant.extraFields.Celular;
        assistantAux.especialidad = assistant.extraFields.Especialidad;
        assistantAux.gradoAcademico = assistant.extraFields.Grado_academico;
        assistantAux.tituloAcademico = assistant.extraFields.Titulo;
        assistantAux.mochila = assistant.extraFields.backpack;
        assistantAux.libro = assistant.extraFields.book;
        assistantAux.playera = assistant.extraFields.t_shirt;
        assistantAux.tallaPlayera = assistant.extraFields.size;
        await items.push(assistantAux);
      });
      return items;
    },
    /********************************************FIN CVDL****************************************/
    /********************************************INICIO The Groom Week****************************************/
    /**
     * Función para descargar el reporte de los asistentes con el formato para estafeta.
     * @param { String } eventName Nombre del evento.
     */
    async downloadEstafetaCsvTheGroomWeek(assistants, eventName) {
      let data = await this.getAssistantsEstafetaTheGroomWeek();
      const fileName = `Reporte estafeta ${eventName}`;
      const exportType = "csv";
      exportFromJSON({ data, fileName, exportType });
    },
    /**
     * Dar formato a lista de asistentes para poder acomodarlos en el archivo .CSV del reporte para estafeta
     * */
    getAssistantsEstafetaTheGroomWeek() {
      /*
        Diferentes columnas del reporte de estafeta
          ticketId
          accessType
          ticketName
          ticketPrice
          name
          lastName
          companyName
          Clinica_o_intitucion
          date
          email
          passwordAccess
          Celular
          tel
          Especialidad
          Grado_academico
          Titulo
          backpack
          book
          t_shirt
          size
          zipCode
          country
          state
          city
          suburb
          street
          outsideNumber
          insideNumber
          placeDescription
       */
      let items = [];
      this.event.assistants.forEach(async assistant => {
        let assistantAux = {
          nombreCorto: '',
          categoria: '',
          nombrePersona: '',
          correoElectronicoUno: '',
          correoElectronicoDos: '',
          pais: '',
          razonSocial: '',
          calleUno: '',
          calleDos: '',
          colonia: '',
          CP: '',
          telefonoConLada: '',
          telefonoCelular: '',
          municipio: '',
          estado: '',
          nombreAsistente: '',
          apellidoAsistente: '',
          //companiaAsistente: '',
          clinicaInsitucion: '',
          tipoAccesso: '',
          nombreAcceso: '',
          precioAcceso: '',
          fechaRegistro: '',
          horaRegistro: '',
          emailAsistente: '',
          contrasenaAsistente: '',
          playera: '',
          tallaPlayera: '',
        };
        console.log(assistant);

        assistantAux.nombreCorto = assistant.attendeeId;
        assistantAux.categoria = 'otros';
        assistantAux.nombrePersona = assistant.name.trim() + ' ' + assistant.lastName.trim();
        assistantAux.correoElectronicoUno = assistant.email;
        assistantAux.correoElectronicoDos = '';
        assistantAux.pais = assistant.extraFields.country;
        assistantAux.razonSocial = assistant.name.trim().split(" ")[0] + " " + assistant.lastName.trim().split(" ")[0];
        // Comprobar si es un registro en el cual se tenía la calle y el número separado. Si es así juntar los campos de street, outsideNumber e insideNumber
        if (assistant.extraFields.outsideNumber) {
          let calleUnoAux = assistant.extraFields.insideNumber && assistant.extraFields.insideNumber!=undefined && assistant.extraFields.insideNumber!=''?(' Int: ' + assistant.extraFields.insideNumber):'';
          assistantAux.calleUno = assistant.extraFields.street.trim() + ' ' + assistant.extraFields.outsideNumber + calleUnoAux;
        } else {
          assistantAux.calleUno = assistant.extraFields.street.trim();
        }
        assistantAux.calleDos = assistant.extraFields.placeDescription;
        assistantAux.colonia = assistant.extraFields.suburb;
        assistantAux.CP = assistant.extraFields.zipCode;
        assistantAux.telefonoConLada = assistant.extraFields.tel;
        assistantAux.telefonoCelular = assistant.extraFields.tel;
        assistantAux.municipio = assistant.extraFields.city;
        assistantAux.estado = assistant.extraFields.state;
        assistantAux.nombreAsistente = assistant.extraFields.name;
        assistantAux.apellidoAsistente = assistant.extraFields.lastName;
        //assistantAux.companiaAsistente = assistant.extraFields.companyName;
        assistantAux.tipoAccesso = assistant.extraFields.accessType;
        assistantAux.nombreAcceso = assistant.extraFields.ticketName;
        assistantAux.precioAcceso = assistant.extraFields.ticketPrice;
        assistantAux.fechaRegistro = assistant.date;
        assistantAux.horaRegistro = assistant.hour;
        assistantAux.emailAsistente = assistant.extraFields.email;
        assistantAux.contrasenaAsistente = assistant.extraFields.passwordAccess;
        assistantAux.playera = assistant.extraFields.Playera;
        assistantAux.tallaPlayera = assistant.extraFields.Talla;
        await items.push(assistantAux);
      });
      return items;
    },
    /********************************************FIN The Groom Week****************************************/
    /**
     * Hacer el check in de los asistentes mediande el switch que se encuentra en la tabla.
     * @param {Object} item Datos del asistente.
     */
    async checkIn(item) {
      try {
        this.checkInData = Object.assign({}, item);
        this.checkInData = {attendeeId: this.checkInData.attendeeId, checkedIn: this.checkInData.checkedIn, orderId: this.checkInData.orderId};
        let result = await this.checkInManual(this.checkInData);
      } catch (error) {
        console.log("No se encontró el asistente");
      }
    },
    /**
     * Función para abrir dialog y cargar datos del asistente para enviar un boleto.
     * @param {Object} item Datos del asistente.
     */
    selectAttendeeTicket(item) {
      this.sendTicketDialog = true;
      this.sendTicketItem = Object.assign({}, item);
    },
    /** Función para abrir dialog y cargar datos del asistente para actualizarlo.
     */
    editAttendee(item) {
      this.modifyDialog = true;
      this.editedItem = Object.assign({}, item);
    },
    /**
     * Función para cerrar dialog de actualizar, ya sea porque el usuario canceló o porque ya se envió el boleto.
     */
    close() {
      this.modifyDialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    /**
     * Función para cerrar dialog de envío de boleto, ya sea porque el usuario canceló o porque ya se envió el boleto.
     */
    closeSendTicket() {
      this.sendTicketDialog = false;
      this.sendTicketItem = Object.assign({}, this.defaultItem);
    },
    /**
     * Función para cerrar dialog de actualizar, ya sea porque el usuario canceló o porque ya se envió el boleto.
     */
    closeAdvancedSearch() {
      this.advancedSearch.dialog = false;
      this.advancedSearch.filter = 'name';
      this.advancedSearch.search = '';
      this.advancedSearch.date = new Date().toISOString().substr(0, 10)
    },
    /**
     * Función para enviar el boleto del asistente seleccionado al email ingresado en el dialog.
     * @param {Object} attendee Datos del asistente
     */
    async sendTicket(attendee) {
      this.closeSendTicket();
      this.checkInData = {attendeeId: this.checkInData.attendeeId, checkedIn: this.checkInData.checkedIn, orderId: this.checkInData.orderId};
      attendee.email = attendee.email.replace(this.patronSpace, "");
      this.ticketData = {orderId: attendee.orderId, attendeeId: attendee.attendeeId, email: attendee.email}
      let result = await this.sendTicketManual(this.ticketData);
      this.show({ text: "¡El boleto ha sido enviado! 😄" });
    },
    /**
     * Función para actualizar asistentes
     */
    async updateAttendeeFunction(attendee){
      try {
        this.load = true
          this.updateData = { 
          orderId: attendee.orderId, 
          attendeeId: attendee.attendeeId,
          name: attendee.name,
          lastName: attendee.lastName,
          companyName: attendee.companyName,
          email: attendee.email,
          tel: attendee.tel,
          passwordAccess: attendee.passwordAccess ? attendee.passwordAccess: "",
        }
        await this.updateAttendee(this.updateData);
        this.close();
        this.clearEventAttendeesInformation()
        this.formatData()
        this.show({ text: "¡El asistente se actualizó correctamente! 😄" });
      } catch (error) {
        console.log(error);
      }finally{
        this.load = false
      }
    },
    /**
     * Función para buscar asistentes principalmente de un listado muy extenso
     */
    async advancedSearchFunction(dataSearch){
      try {
        this.disabledAttendeesButton = false;
        this.advancedSearch.load = true
        function eliminarDiacriticos(texto) {
            return texto.normalize('NFD').replace(/[\u0300-\u036f]/g,"");
        }
          let data = { 
            search: eliminarDiacriticos(dataSearch.search).toLowerCase(), 
            date: dataSearch.date, 
            filter: dataSearch.filter,
            eventId: this.$route.params.id
          }
        this.clearEventAttendeesInformation()
        await this.searchAttendee(data);
        this.format()
        this.advancedSearch.verify = true
        this.closeAdvancedSearch();
        if(this.event.assistants.length === 0){
          this.show({ text: "¡No se encontraron resultados!" });
        }
      } catch (error) {
        console.log(error);
        this.show({
          text:
            "¡Consulte con soporte técnico WeChamber!",
          color: "danger",
        });
      }finally{
        this.advancedSearch.load = false
      }
    },
    /**
     * Función que ayuda a acomodar la lista de asistentes para que sean mostrados en la tabla de la forma correcta.
     */
    async formatData() {
      if (this.advancedSearch.verify) {
        this.clearEventAttendeesInformation();
      }
      this.advancedSearch.verify = false;
      await this.fetchEventsAttendeeApi({eventId: this.$route.params.id, recordsQuantity:400, pageNumber: this.pageNumber});
      this.format();
    },
    format() {
      let newArray2 = [];
      this.eventAttendees.orders.map(order => {
        order.attendeeInformation.map(attendee => {
          let newAttendee = {
            attendeeId: attendee._id,
            name: attendee.name,
            lastName: attendee.lastName,
            companyName: attendee.companyName!=""?attendee.companyName:"",
            email: attendee.email,
            tel: attendee.tel != ""?attendee.tel:"",
            passwordAccess: attendee.passwordAccess,
            productName: attendee.ticketName,
            //date: new Date(order.createdAt).toLocaleDateString("es-MX"),
            date: this.formatDate(order.updatedAt),
            hour: this.formatHour(order.updatedAt),
            checkedIn: attendee.checkedIn,
            extraFields: JSON.parse(attendee.extraFields),
            buyer: `${order.paymentInformation.name} ${order.paymentInformation.lastName}`,
            orderId: order._id,
            //paymentType: order.paymentInformation.paymentType,
            //billingAddress: order.billingInformation?order.billingInformation.address: '', 
            //billingEmail: order.billingInformation?order.billingInformation.email: '',
            //billingFormaDePago: order.billingInformation?order.billingInformation.formaDePago: '',
            //billingMetodoDePago: order.billingInformation?order.billingInformation.metodoDePago: '',
            //billingRazonSocial: order.billingInformation?order.billingInformation.razonSocialONombreFiscal: '',
            //billingRFC: order.billingInformation?order.billingInformation.rfc: '',
            //billingUsoDelCFDI: order.billingInformation?order.billingInformation.usoDelCfdi: '',
            //billingZipCode: order.billingInformation?order.billingInformation.zipCode: '',
            //total: order.total
          };
          newArray2.push(newAttendee);
        });
      });
      this.event.id = this.eventAttendees.id;
      this.event.name = this.eventAttendees.name;
      this.event.attendeeWithPassword = this.eventAttendees.attendeeWithPassword;
      this.event.assistants = newArray2;
      this.items = this.event.assistants;
      this.loading = false
    },
    /**
     * Función para cargar más asistentes
     * (ESTA FUNCIÓN CONSULTA LOS ASISTENTES EN BLOQUES DE 400 y los va almacenando)
     */
    async fetchMoreAttendees() {
      try {
        this.loadingMoreAttendees = true;
        this.allQtyOrdersOld = this.eventAttendees.orders.length;
        this.pageNumber++;
        await this.formatData();
        this.allQtyOrdersNew = this.eventAttendees.orders.length;
        if (this.allQtyOrdersNew == this.allQtyOrdersOld) {
          this.disabledAttendeesButton = true;
        }
        this.loadingMoreAttendees = false;
      } catch (error) {
        console.error(error);
        this.loadingMoreAttendees = false;
      }
    },
    /**
     * Función que obtiene la fecha de la transacción con el siguiente formato DD/MM/YYYY
     * @param {Date} date Valor de la fecha.
     */
    formatDate(date) {
      let newDate = new Date(date);
      return `${newDate.getDate()}/${newDate.getMonth()+1}/${newDate.getFullYear()}`
    },
    /**
     * Función que obtiene la hora de la transacción con el siguiente formato HH:MM A.M./P.M.
     * @param {Date} date Valor de la fecha.
     */
    formatHour(date) {
      let time = new Date(date);
      var hour = time.getHours();
      var minute = time.getMinutes();
      //var second = time.getSeconds();
      var temp = '' + ((hour > 12) ? hour - 12 : hour);
      if (hour == 0)
        temp = '12';
      temp += ((minute < 10) ? ':0' : ':') + minute;
      //temp += ((second < 10) ? ':0' : ':') + second;
      temp += (hour >= 12) ? ' P.M.' : ' A.M.';
      return temp;
    }
  },
  async mounted() {
    await this.formatData();
    console.log("Datos del usuario");
    console.log(this.user);
  },
  destroyed() {
    this.clearEventAttendeesInformation();
  }
};
</script>
<style scoped>
.attended-color {
  background-color: rgba(83, 165, 72, 0.2);
}
</style>